export default __webpack_public_path__ + "static/media/les_copy_invert.7d3bc6e9.svg";